"use client";

// src/locales/fr_FR.json
var fr_FR_default = `{
  "connect_wallet": {
    "label": "Connecter le portefeuille",
    "wrong_network": {
      "label": "R\xE9seau incorrect"
    }
  },
  "intro": {
    "title": "Qu'est-ce qu'un portefeuille?",
    "description": "Un portefeuille est utilis\xE9 pour envoyer, recevoir, stocker et afficher des actifs num\xE9riques. C'est aussi une nouvelle fa\xE7on de se connecter, sans avoir besoin de cr\xE9er de nouveaux comptes et mots de passe sur chaque site.",
    "digital_asset": {
      "title": "Un foyer pour vos actifs num\xE9riques",
      "description": "Les portefeuilles sont utilis\xE9s pour envoyer, recevoir, stocker et afficher des actifs num\xE9riques comme Ethereum et les NFTs."
    },
    "login": {
      "title": "Une nouvelle fa\xE7on de se connecter",
      "description": "Au lieu de cr\xE9er de nouveaux comptes et mots de passe sur chaque site Web, connectez simplement votre portefeuille."
    },
    "get": {
      "label": "Obtenir un portefeuille"
    },
    "learn_more": {
      "label": "En savoir plus"
    }
  },
  "sign_in": {
    "label": "V\xE9rifiez votre compte",
    "description": "Pour terminer la connexion, vous devez signer un message dans votre portefeuille pour v\xE9rifier que vous \xEAtes le propri\xE9taire de ce compte.",
    "message": {
      "send": "Envoyer le message",
      "preparing": "Pr\xE9paration du message...",
      "cancel": "Annuler",
      "preparing_error": "Erreur lors de la pr\xE9paration du message, veuillez r\xE9essayer!"
    },
    "signature": {
      "waiting": "En attente de la signature...",
      "verifying": "V\xE9rification de la signature...",
      "signing_error": "Erreur lors de la signature du message, veuillez r\xE9essayer!",
      "verifying_error": "Erreur lors de la v\xE9rification de la signature, veuillez r\xE9essayer!",
      "oops_error": "Oups, quelque chose a mal tourn\xE9!"
    }
  },
  "connect": {
    "label": "Connecter",
    "title": "Connecter un portefeuille",
    "new_to_ethereum": {
      "description": "Nouveau aux portefeuilles Ethereum?",
      "learn_more": {
        "label": "En savoir plus"
      }
    },
    "learn_more": {
      "label": "En savoir plus"
    },
    "recent": "R\xE9cents",
    "status": {
      "opening": "Ouverture %{wallet}...",
      "connecting": "Connect :)ing",
      "connect_mobile": "Continuer dans %{wallet}",
      "not_installed": "%{wallet} n'est pas install\xE9",
      "not_available": "%{wallet} n'est pas disponible",
      "confirm": "Confirmez la connexion dans l'extension",
      "confirm_mobile": "Accepter la demande de connexion dans le portefeuille"
    },
    "secondary_action": {
      "get": {
        "description": "Vous n'avez pas de %{wallet}?",
        "label": "OBTENIR"
      },
      "install": {
        "label": "INSTALLER"
      },
      "retry": {
        "label": "R\xC9ESSAYER"
      }
    },
    "walletconnect": {
      "description": {
        "full": "Vous avez besoin du modal officiel de WalletConnect ?",
        "compact": "Besoin du modal de WalletConnect ?"
      },
      "open": {
        "label": "OUVRIR"
      }
    }
  },
  "connect_scan": {
    "title": "Scannez avec %{wallet}",
    "fallback_title": "Scannez avec votre t\xE9l\xE9phone"
  },
  "connector_group": {
    "installed": "Install\xE9",
    "recommended": "Recommand\xE9",
    "other": "Autre",
    "popular": "Populaire",
    "more": "Plus",
    "others": "Autres"
  },
  "get": {
    "title": "Obtenez un portefeuille",
    "action": {
      "label": "OBTENIR"
    },
    "mobile": {
      "description": "Portefeuille mobile"
    },
    "extension": {
      "description": "Extension de navigateur"
    },
    "mobile_and_extension": {
      "description": "Portefeuille mobile et extension"
    },
    "mobile_and_desktop": {
      "description": "Portefeuille mobile et de bureau"
    },
    "looking_for": {
      "title": "Ce n'est pas ce que vous cherchez ?",
      "mobile": {
        "description": "S\xE9lectionnez un portefeuille sur l'\xE9cran principal pour commencer avec un autre fournisseur de portefeuille."
      },
      "desktop": {
        "compact_description": "S\xE9lectionnez un portefeuille sur l'\xE9cran principal pour commencer avec un autre fournisseur de portefeuille.",
        "wide_description": "S\xE9lectionnez un portefeuille sur la gauche pour commencer avec un autre fournisseur de portefeuille."
      }
    }
  },
  "get_options": {
    "title": "Commencez avec %{wallet}",
    "short_title": "Obtenez %{wallet}",
    "mobile": {
      "title": "%{wallet} pour mobile",
      "description": "Utilisez le portefeuille mobile pour explorer le monde d'Ethereum.",
      "download": {
        "label": "Obtenez l'application"
      }
    },
    "extension": {
      "title": "%{wallet} pour %{browser}",
      "description": "Acc\xE9dez \xE0 votre portefeuille directement depuis votre navigateur web pr\xE9f\xE9r\xE9.",
      "download": {
        "label": "Ajouter \xE0 %{browser}"
      }
    },
    "desktop": {
      "title": "%{wallet} pour %{platform}",
      "description": "Acc\xE9dez \xE0 votre portefeuille nativement depuis votre puissant ordinateur de bureau.",
      "download": {
        "label": "Ajouter \xE0 %{platform}"
      }
    }
  },
  "get_mobile": {
    "title": "Installer %{wallet}",
    "description": "Scannez avec votre t\xE9l\xE9phone pour t\xE9l\xE9charger sur iOS ou Android",
    "continue": {
      "label": "Continuer"
    }
  },
  "get_instructions": {
    "mobile": {
      "connect": {
        "label": "Connecter"
      },
      "learn_more": {
        "label": "En savoir plus"
      }
    },
    "extension": {
      "refresh": {
        "label": "Rafra\xEEchir"
      },
      "learn_more": {
        "label": "En savoir plus"
      }
    },
    "desktop": {
      "connect": {
        "label": "Connecter"
      },
      "learn_more": {
        "label": "En savoir plus"
      }
    }
  },
  "chains": {
    "title": "Changer de r\xE9seau",
    "wrong_network": "Mauvais r\xE9seau d\xE9tect\xE9, changez ou d\xE9connectez-vous pour continuer.",
    "confirm": "Confirmer dans le portefeuille",
    "switching_not_supported": "Votre portefeuille ne supporte pas le changement de r\xE9seau depuis %{appName}. Essayez de changer de r\xE9seau depuis votre portefeuille.",
    "switching_not_supported_fallback": "Votre portefeuille ne prend pas en charge le changement de r\xE9seau \xE0 partir de cette application. Essayez de changer de r\xE9seau \xE0 partir de votre portefeuille \xE0 la place.",
    "disconnect": "D\xE9connecter",
    "connected": "Connect\xE9"
  },
  "profile": {
    "disconnect": {
      "label": "D\xE9connecter"
    },
    "copy_address": {
      "label": "Copier l'adresse",
      "copied": "Copi\xE9 !"
    },
    "explorer": {
      "label": "Voir plus sur l'explorateur"
    },
    "transactions": {
      "description": "%{appName} transactions appara\xEEtront ici...",
      "description_fallback": "Vos transactions appara\xEEtront ici...",
      "recent": {
        "title": "Transactions R\xE9centes"
      },
      "clear": {
        "label": "Tout supprimer"
      }
    }
  },
  "wallet_connectors": {
    "argent": {
      "qr_code": {
        "step1": {
          "description": "Mettez Argent sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Ouvrez l'application Argent"
        },
        "step2": {
          "description": "Cr\xE9ez un portefeuille et un nom d'utilisateur, ou importez un portefeuille existant.",
          "title": "Cr\xE9er ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton Scan QR"
        }
      }
    },
    "berasig": {
      "extension": {
        "step1": {
          "title": "Installez l'extension BeraSig",
          "description": "Nous vous recommandons d'\xE9pingler BeraSig \xE0 votre barre des t\xE2ches pour un acc\xE8s plus facile \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er un Portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
        }
      }
    },
    "best": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Best Wallet",
          "description": "Ajoutez Best Wallet \xE0 votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Touchez l'ic\xF4ne QR et scannez",
          "description": "Touchez l'ic\xF4ne QR sur votre \xE9cran d'accueil, scannez le code et confirmez l'invite pour vous connecter."
        }
      }
    },
    "bifrost": {
      "qr_code": {
        "step1": {
          "description": "Nous vous recommandons de mettre le portefeuille Bifrost sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide.",
          "title": "Ouvrez l'application Bifrost Wallet"
        },
        "step2": {
          "description": "Cr\xE9ez ou importez un portefeuille en utilisant votre phrase de r\xE9cup\xE9ration.",
          "title": "Cr\xE9er ou Importer un portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s votre scan, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton de scan"
        }
      }
    },
    "bitget": {
      "qr_code": {
        "step1": {
          "description": "Nous vous recommandons de placer Bitget Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide.",
          "title": "Ouvrez l'application Bitget Wallet"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque.",
          "title": "Cr\xE9er ou Importer un portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s le scan, une incitation de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton de scan"
        }
      },
      "extension": {
        "step1": {
          "description": "Nous vous recommandons d'\xE9pingler Bitget Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Installez l'extension de portefeuille Bitget"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne.",
          "title": "Cr\xE9ez ou Importez un portefeuille"
        },
        "step3": {
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension.",
          "title": "Rafra\xEEchissez votre navigateur"
        }
      }
    },
    "bitski": {
      "extension": {
        "step1": {
          "description": "Nous recommandons d'\xE9pingler Bitski \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Installez l'extension Bitski"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec qui que ce soit.",
          "title": "Cr\xE9er ou Importer un portefeuille"
        },
        "step3": {
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension.",
          "title": "Rafra\xEEchissez votre navigateur"
        }
      }
    },
    "bitverse": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Bitverse Wallet",
          "description": "Ajoutez Bitverse Wallet \xE0 votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Touchez l'ic\xF4ne QR et scannez",
          "description": "Touchez l'ic\xF4ne QR sur votre \xE9cran d'accueil, scannez le code et confirmez l'invite pour vous connecter."
        }
      }
    },
    "bloom": {
      "desktop": {
        "step1": {
          "title": "Ouvrez l'application Bloom Wallet",
          "description": "Nous recommandons de placer Bloom Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
        },
        "step2": {
          "description": "Cr\xE9ez ou importez un portefeuille en utilisant votre phrase de r\xE9cup\xE9ration.",
          "title": "Cr\xE9er ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s avoir obtenu un portefeuille, cliquez sur Connecter pour vous connecter via Bloom. Une invite de connexion appara\xEEtra dans l'application pour que vous confirmiez la connexion.",
          "title": "Cliquez sur Connecter"
        }
      }
    },
    "bybit": {
      "qr_code": {
        "step1": {
          "description": "Nous recommandons de placer Bybit sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Ouvrez l'application Bybit"
        },
        "step2": {
          "description": "Vous pouvez facilement sauvegarder votre portefeuille en utilisant notre fonction de sauvegarde sur votre t\xE9l\xE9phone.",
          "title": "Cr\xE9er ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton de scan"
        }
      },
      "extension": {
        "step1": {
          "description": "Cliquez en haut \xE0 droite de votre navigateur et \xE9pinglez le portefeuille Bybit pour un acc\xE8s facile.",
          "title": "Installez l'extension Bybit Wallet"
        },
        "step2": {
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant.",
          "title": "Cr\xE9er ou Importer un portefeuille"
        },
        "step3": {
          "description": "Une fois que vous avez configur\xE9 Bybit Wallet, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension.",
          "title": "Rafra\xEEchissez votre navigateur"
        }
      }
    },
    "binance": {
      "qr_code": {
        "step1": {
          "description": "Nous vous recommandons de mettre Binance sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Ouvrez l'application Binance"
        },
        "step2": {
          "description": "Vous pouvez facilement sauvegarder votre portefeuille en utilisant notre fonction de sauvegarde sur votre t\xE9l\xE9phone.",
          "title": "Cr\xE9er ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton WalletConnect"
        }
      }
    },
    "coin98": {
      "qr_code": {
        "step1": {
          "description": "Nous vous recommandons de placer Coin98 Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Ouvrez l'application Coin98 Wallet"
        },
        "step2": {
          "description": "Vous pouvez facilement sauvegarder votre portefeuille en utilisant notre fonction de sauvegarde sur votre t\xE9l\xE9phone.",
          "title": "Cr\xE9er ou Importer un portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s que vous ayez scann\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton WalletConnect"
        }
      },
      "extension": {
        "step1": {
          "description": "Cliquez en haut \xE0 droite de votre navigateur et \xE9pinglez Coin98 Wallet pour un acc\xE8s facile.",
          "title": "Installez l'extension Coin98 Wallet"
        },
        "step2": {
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant.",
          "title": "Cr\xE9er ou Importer un portefeuille"
        },
        "step3": {
          "description": "Une fois que vous avez configur\xE9 Coin98 Wallet, cliquez ci-dessous pour actualiser le navigateur et charger l'extension.",
          "title": "Rafra\xEEchissez votre navigateur"
        }
      }
    },
    "coinbase": {
      "qr_code": {
        "step1": {
          "description": "Nous recommandons de placer Coinbase Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide.",
          "title": "Ouvrez l'application Coinbase Wallet"
        },
        "step2": {
          "description": "Vous pouvez facilement sauvegarder votre portefeuille en utilisant la fonction de sauvegarde cloud.",
          "title": "Cr\xE9er ou Importer un portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s avoir scann\xE9, une invite de connexion s'affichera pour que vous puissiez connecter votre portefeuille.",
          "title": "Appuyez sur le bouton de scan"
        }
      },
      "extension": {
        "step1": {
          "description": "Nous recommandons d'\xE9pingler Coinbase Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Installez l'extension Coinbase Wallet"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xFBre. Ne partagez jamais votre phrase secr\xE8te avec quiconque.",
          "title": "Cr\xE9er ou Importer un portefeuille"
        },
        "step3": {
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension.",
          "title": "Actualisez votre navigateur"
        }
      }
    },
    "compass": {
      "extension": {
        "step1": {
          "description": "Nous vous recommandons d'\xE9pingler Compass Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Installez l'extension Compass Wallet"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque.",
          "title": "Cr\xE9er ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension.",
          "title": "Rafra\xEEchissez votre navigateur"
        }
      }
    },
    "core": {
      "qr_code": {
        "step1": {
          "description": "Nous recommandons de placer Core sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Ouvrez l'application Core"
        },
        "step2": {
          "description": "Vous pouvez facilement sauvegarder votre portefeuille en utilisant notre fonction de sauvegarde sur votre t\xE9l\xE9phone.",
          "title": "Cr\xE9er ou Importer un portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s avoir scann\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton WalletConnect"
        }
      },
      "extension": {
        "step1": {
          "description": "Nous recommandons d'\xE9pingler Core \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Installez l'extension Core"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque.",
          "title": "Cr\xE9ez ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension.",
          "title": "Rafra\xEEchissez votre navigateur"
        }
      }
    },
    "fox": {
      "qr_code": {
        "step1": {
          "description": "Nous recommandons de mettre FoxWallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide.",
          "title": "Ouvrez l'application FoxWallet"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne.",
          "title": "Cr\xE9er ou Importer un portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s avoir scann\xE9, une invitation \xE0 la connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton de scan"
        }
      }
    },
    "frontier": {
      "qr_code": {
        "step1": {
          "description": "Nous vous recommandons de placer le portefeuille Frontier sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide.",
          "title": "Ouvrez l'application Frontier Wallet"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne.",
          "title": "Cr\xE9er ou Importer un portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s avoir scann\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton de scan"
        }
      },
      "extension": {
        "step1": {
          "description": "Nous recommandons d'\xE9pingler Frontier Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Installez l'extension Frontier Wallet"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne.",
          "title": "Cr\xE9ez ou importez un portefeuille"
        },
        "step3": {
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension.",
          "title": "Rafra\xEEchissez votre navigateur"
        }
      }
    },
    "im_token": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application imToken",
          "description": "Placez l'application imToken sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9ez ou importez un portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant ."
        },
        "step3": {
          "title": "Appuyez sur l'ic\xF4ne du scanner dans le coin sup\xE9rieur droit",
          "description": "Choisissez Nouvelle Connexion, puis scannez le code QR et confirmez l'invite pour vous connecter."
        }
      }
    },
    "iopay": {
      "qr_code": {
        "step1": {
          "description": "Nous recommandons de placer ioPay sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Ouvrez l'application ioPay"
        },
        "step2": {
          "description": "Vous pouvez facilement sauvegarder votre portefeuille en utilisant notre fonction de sauvegarde sur votre t\xE9l\xE9phone.",
          "title": "Cr\xE9er ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton WalletConnect"
        }
      }
    },
    "kaikas": {
      "extension": {
        "step1": {
          "description": "Nous recommandons d'\xE9pingler Kaikas \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Installez l'extension Kaikas"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque.",
          "title": "Cr\xE9er ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension.",
          "title": "Rafra\xEEchissez votre navigateur"
        }
      },
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Kaikas",
          "description": "Placez l'application Kaikas sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Appuyez sur l'ic\xF4ne du scanner dans le coin sup\xE9rieur droit",
          "description": "Choisissez Nouvelle Connexion, puis scannez le code QR et confirmez l'invite pour vous connecter."
        }
      }
    },
    "kaia": {
      "extension": {
        "step1": {
          "description": "Nous vous recommandons d'\xE9pingler Kaia \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Installez l'extension Kaia"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque.",
          "title": "Cr\xE9er ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension.",
          "title": "Rafra\xEEchissez votre navigateur"
        }
      },
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Kaia",
          "description": "Mettez l'application Kaia sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Appuyez sur l'ic\xF4ne du scanner dans le coin sup\xE9rieur droit",
          "description": "Choisissez Nouvelle Connexion, puis scannez le code QR et confirmez l'invite pour vous connecter."
        }
      }
    },
    "kraken": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Kraken Wallet",
          "description": "Ajoutez Kraken Wallet \xE0 votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Touchez l'ic\xF4ne QR et scannez",
          "description": "Touchez l'ic\xF4ne QR sur votre \xE9cran d'accueil, scannez le code et confirmez l'invite pour vous connecter."
        }
      }
    },
    "kresus": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Kresus Wallet",
          "description": "Ajoutez Kresus Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Touchez l'ic\xF4ne QR et scannez",
          "description": "Touchez l'ic\xF4ne QR sur votre \xE9cran d'accueil, scannez le code et confirmez l'invite pour vous connecter."
        }
      }
    },
    "magicEden": {
      "extension": {
        "step1": {
          "title": "Installez l'extension Magic Eden",
          "description": "Nous vous recommandons d'\xE9pingler Magic Eden \xE0 votre barre des t\xE2ches pour un acc\xE8s plus facile \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase de r\xE9cup\xE9ration secr\xE8te avec personne."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
        }
      }
    },
    "metamask": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application MetaMask",
          "description": "Nous vous recommandons de mettre MetaMask sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Veillez \xE0 sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec qui que ce soit."
        },
        "step3": {
          "title": "Appuyez sur le bouton de scan",
          "description": "Apr\xE8s avoir scann\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille."
        }
      },
      "extension": {
        "step1": {
          "title": "Installez l\u2019extension de MetaMask",
          "description": "Nous recommandons d'\xE9pingler MetaMask \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
        }
      }
    },
    "nestwallet": {
      "extension": {
        "step1": {
          "title": "Installez l'extension NestWallet",
          "description": "Nous vous recommandons d'\xE9pingler NestWallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
        }
      }
    },
    "okx": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application OKX Wallet",
          "description": "Nous recommandons de mettre OKX Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
        },
        "step3": {
          "title": "Appuyez sur le bouton de num\xE9risation",
          "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille."
        }
      },
      "extension": {
        "step1": {
          "title": "Installez l'extension de portefeuille OKX",
          "description": "Nous vous recommandons d'\xE9pingler le portefeuille OKX \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
        }
      }
    },
    "omni": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Omni",
          "description": "Ajoutez Omni \xE0 votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Touchez l'ic\xF4ne QR et scannez",
          "description": "Appuyez sur l'ic\xF4ne QR sur votre \xE9cran d'accueil, scannez le code et confirmez l'invite pour vous connecter."
        }
      }
    },
    "1inch": {
      "qr_code": {
        "step1": {
          "description": "Placez 1inch Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Ouvrez l'application 1inch Wallet"
        },
        "step2": {
          "description": "Cr\xE9ez un portefeuille et un nom d'utilisateur, ou importez un portefeuille existant.",
          "title": "Cr\xE9er ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton Scan QR"
        }
      }
    },
    "token_pocket": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application TokenPocket",
          "description": "Nous vous recommandons de mettre TokenPocket sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
        },
        "step2": {
          "title": "Cr\xE9ez ou Importer un portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille \xE0 l'aide d'une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec qui que ce soit."
        },
        "step3": {
          "title": "Appuyez sur le bouton de scan",
          "description": "Apr\xE8s votre scan, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille."
        }
      },
      "extension": {
        "step1": {
          "title": "Installez l'extension TokenPocket",
          "description": "Nous recommandons d'\xE9pingler TokenPocket \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec qui que ce soit."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
        }
      }
    },
    "trust": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Trust Wallet",
          "description": "Placez Trust Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un portefeuille",
          "description": "Cr\xE9er un nouveau portefeuille ou en importer un existant."
        },
        "step3": {
          "title": "Appuyez sur WalletConnect dans les param\xE8tres",
          "description": "Choisissez Nouvelle Connexion, puis scannez le code QR et confirmez l'invite pour vous connecter."
        }
      },
      "extension": {
        "step1": {
          "title": "Installez l'extension Trust Wallet",
          "description": "Cliquez en haut \xE0 droite de votre navigateur et \xE9pinglez Trust Wallet pour un acc\xE8s facile."
        },
        "step2": {
          "title": "Cr\xE9er ou importer un portefeuille",
          "description": "Cr\xE9er un nouveau portefeuille ou en importer un existant."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 Trust Wallet, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
        }
      }
    },
    "uniswap": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Uniswap",
          "description": "Ajoutez Uniswap Wallet \xE0 votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9ez ou importez un portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Tapez sur l'ic\xF4ne QR et scannez",
          "description": "Touchez l'ic\xF4ne QR sur votre \xE9cran d'accueil, scannez le code et confirmez l'invite pour vous connecter."
        }
      }
    },
    "zerion": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Zerion",
          "description": "Nous vous recommandons de mettre Zerion sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne."
        },
        "step3": {
          "title": "Appuyez sur le bouton de scan",
          "description": "Une fois que vous avez scann\xE9, une invite de connexion appara\xEEtra pour que vous puissiez connecter votre portefeuille."
        }
      },
      "extension": {
        "step1": {
          "title": "Installer l'extension Zerion",
          "description": "Nous recommandons d'\xE9pingler Zerion \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9ez ou Importez un portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
        }
      }
    },
    "rainbow": {
      "qr_code": {
        "step1": {
          "title": "Ouvre l'application Rainbow",
          "description": "Nous vous recommandons de mettre Rainbow sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9ez ou Importez un portefeuille",
          "description": "Vous pouvez facilement sauvegarder votre portefeuille en utilisant notre fonction de sauvegarde sur votre t\xE9l\xE9phone."
        },
        "step3": {
          "title": "Appuyez sur le bouton de scan",
          "description": "Apr\xE8s avoir scann\xE9, une invite de connexion appara\xEEtra pour que vous connectiez votre portefeuille."
        }
      }
    },
    "enkrypt": {
      "extension": {
        "step1": {
          "description": "Nous vous recommandons d'\xE9pingler Enkrypt Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Installez l'extension Enkrypt Wallet"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quelqu'un.",
          "title": "Cr\xE9er ou Importer un portefeuille"
        },
        "step3": {
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l\u2019extension.",
          "title": "Rafra\xEEchissez votre navigateur"
        }
      }
    },
    "frame": {
      "extension": {
        "step1": {
          "description": "Nous vous recommandons d'\xE9pingler Frame \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Installez Frame & l'extension compl\xE9mentaire"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille \xE0 l'aide d'une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne.",
          "title": "Cr\xE9er ou Importer un portefeuille"
        },
        "step3": {
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension.",
          "title": "Rafra\xEEchissez votre navigateur"
        }
      }
    },
    "one_key": {
      "extension": {
        "step1": {
          "title": "Installez l'extension OneKey Wallet",
          "description": "Nous vous recommandons d'\xE9pingler OneKey Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
        }
      }
    },
    "paraswap": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application ParaSwap",
          "description": "Ajoutez ParaSwap Wallet \xE0 votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Touchez l'ic\xF4ne QR et scannez",
          "description": "Touchez l'ic\xF4ne QR sur votre \xE9cran d'accueil, scannez le code et confirmez l'invite pour vous connecter."
        }
      }
    },
    "phantom": {
      "extension": {
        "step1": {
          "title": "Installez l'extension Phantom",
          "description": "Nous vous recommandons d'\xE9pingler Phantom \xE0 votre barre des t\xE2ches pour un acc\xE8s plus facile \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase de r\xE9cup\xE9ration secr\xE8te avec personne."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
        }
      }
    },
    "rabby": {
      "extension": {
        "step1": {
          "title": "Installez l'extension Rabby",
          "description": "Nous recommandons d'\xE9pingler Rabby \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec qui que ce soit."
        },
        "step3": {
          "title": "Actualisez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
        }
      }
    },
    "ronin": {
      "qr_code": {
        "step1": {
          "description": "Nous recommandons de placer Ronin Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide.",
          "title": "Ouvrez l'application Ronin Wallet"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque.",
          "title": "Cr\xE9er ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton de scan"
        }
      },
      "extension": {
        "step1": {
          "description": "Nous recommandons d'\xE9pingler Ronin Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Installez l'extension Ronin Wallet"
        },
        "step2": {
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque.",
          "title": "Cr\xE9er ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension.",
          "title": "Rafra\xEEchissez votre navigateur"
        }
      }
    },
    "ramper": {
      "extension": {
        "step1": {
          "title": "Installez l'extension Ramper",
          "description": "Nous recommandons d'\xE9pingler Ramper \xE0 votre barre des t\xE2ches pour un acc\xE8s plus facile \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er un Portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
        }
      }
    },
    "safeheron": {
      "extension": {
        "step1": {
          "title": "Installez l'extension Core",
          "description": "Nous recommandons d'\xE9pingler Safeheron \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quelqu'un."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
        }
      }
    },
    "taho": {
      "extension": {
        "step1": {
          "title": "Installez l'extension Taho",
          "description": "Nous vous recommandons d'\xE9pingler Taho \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9ez ou Importez un portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quelqu'un."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
        }
      }
    },
    "wigwam": {
      "extension": {
        "step1": {
          "title": "Installez l'extension Wigwam",
          "description": "Nous vous recommandons d'\xE9pingler Wigwam \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
        }
      }
    },
    "talisman": {
      "extension": {
        "step1": {
          "title": "Installez l'extension Talisman",
          "description": "Nous vous recommandons d'\xE9pingler Talisman \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou importer un portefeuille Ethereum",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase de r\xE9cup\xE9ration avec personne."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
        }
      }
    },
    "xdefi": {
      "extension": {
        "step1": {
          "title": "Installez l'extension du portefeuille XDEFI",
          "description": "Nous vous recommandons d'\xE9pingler XDEFI Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec qui que ce soit."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
        }
      }
    },
    "zeal": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Zeal",
          "description": "Ajoutez Zeal Wallet \xE0 votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Touchez l'ic\xF4ne QR et scannez",
          "description": "Touchez l'ic\xF4ne QR sur votre \xE9cran d'accueil, scannez le code et confirmez l'invite pour vous connecter."
        }
      },
      "extension": {
        "step1": {
          "title": "Installez l'extension Zeal",
          "description": "Nous vous recommandons d'\xE9pingler Zeal \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
        }
      }
    },
    "safepal": {
      "extension": {
        "step1": {
          "title": "Installez l'extension SafePal Wallet",
          "description": "Cliquez en haut \xE0 droite de votre navigateur et \xE9pinglez SafePal Wallet pour un acc\xE8s facile."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 SafePal Wallet, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
        }
      },
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application SafePal Wallet",
          "description": "Mettez SafePal Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Appuyez sur WalletConnect dans les param\xE8tres",
          "description": "Choisissez Nouvelle Connexion, puis scannez le code QR et confirmez l'invite pour vous connecter."
        }
      }
    },
    "desig": {
      "extension": {
        "step1": {
          "title": "Installez l'extension Desig",
          "description": "Nous vous recommandons d'\xE9pingler Desig \xE0 votre barre des t\xE2ches pour un acc\xE8s plus facile \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er un Portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
        }
      }
    },
    "subwallet": {
      "extension": {
        "step1": {
          "title": "Installez l'extension SubWallet",
          "description": "Nous vous recommandons d'\xE9pingler SubWallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase de r\xE9cup\xE9ration avec personne."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
        }
      },
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application SubWallet",
          "description": "Nous vous recommandons de mettre SubWallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
        },
        "step3": {
          "title": "Appuyez sur le bouton de scan",
          "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille."
        }
      }
    },
    "clv": {
      "extension": {
        "step1": {
          "title": "Installez l'extension CLV Wallet",
          "description": "Nous vous recommandons d'\xE9pingler CLV Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
        }
      },
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application CLV Wallet",
          "description": "Nous vous recommandons de mettre CLV Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
        },
        "step3": {
          "title": "Appuyez sur le bouton de scan",
          "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille."
        }
      }
    },
    "okto": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Okto",
          "description": "Ajoutez Okto \xE0 votre \xE9cran d'accueil pour un acc\xE8s rapide"
        },
        "step2": {
          "title": "Cr\xE9er un portefeuille MPC",
          "description": "Cr\xE9ez un compte et g\xE9n\xE9rez un portefeuille"
        },
        "step3": {
          "title": "Appuyez sur WalletConnect dans les param\xE8tres",
          "description": "Touchez l'ic\xF4ne 'Scan QR' en haut \xE0 droite et confirmez l'invite pour vous connecter."
        }
      }
    },
    "ledger": {
      "desktop": {
        "step1": {
          "title": "Ouvrez l'application Ledger Live",
          "description": "Nous vous recommandons de mettre Ledger Live sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
        },
        "step2": {
          "title": "Configurez votre Ledger",
          "description": "Configurez un nouveau Ledger ou connectez-vous \xE0 un existant."
        },
        "step3": {
          "title": "Connecter",
          "description": "Une fois que vous avez scann\xE9, une invite de connexion appara\xEEtra pour que vous puissiez connecter votre portefeuille."
        }
      },
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Ledger Live",
          "description": "Nous vous recommandons de mettre Ledger Live sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
        },
        "step2": {
          "title": "Configurez votre Ledger",
          "description": "Vous pouvez soit synchroniser avec l'application de bureau, soit connecter votre Ledger."
        },
        "step3": {
          "title": "Scannez le code",
          "description": "Appuyez sur WalletConnect puis passez au Scanner. Une fois que vous avez scann\xE9, une invite de connexion appara\xEEtra pour que vous puissiez connecter votre portefeuille."
        }
      }
    },
    "valora": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Valora",
          "description": "Nous vous recommandons de mettre Valora sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
        },
        "step2": {
          "title": "Cr\xE9er ou importer un portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Appuyez sur le bouton de scan",
          "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille."
        }
      }
    },
    "gate": {
      "qr_code": {
        "step1": {
          "title": "Ouvrez l'application Gate",
          "description": "Nous vous recommandons de mettre Gate sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
        },
        "step3": {
          "title": "Appuyez sur le bouton de scan",
          "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille."
        }
      },
      "extension": {
        "step1": {
          "title": "Installez l'extension Gate",
          "description": "Nous vous recommandons d'\xE9pingler Gate \xE0 votre barre des t\xE2ches pour un acc\xE8s plus facile \xE0 votre portefeuille."
        },
        "step2": {
          "title": "Cr\xE9er ou Importer un Portefeuille",
          "description": "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase de r\xE9cup\xE9ration secr\xE8te avec personne."
        },
        "step3": {
          "title": "Rafra\xEEchissez votre navigateur",
          "description": "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
        }
      }
    },
    "xportal": {
      "qr_code": {
        "step1": {
          "description": "Mettez xPortal sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
          "title": "Ouvrez l'application xPortal"
        },
        "step2": {
          "description": "Cr\xE9ez un portefeuille ou importez-en un existant.",
          "title": "Cr\xE9er ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton Scan QR"
        }
      }
    },
    "mew": {
      "qr_code": {
        "step1": {
          "description": "Nous vous recommandons de mettre MEW Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide.",
          "title": "Ouvrez l'application MEW Wallet"
        },
        "step2": {
          "description": "Vous pouvez facilement sauvegarder votre portefeuille en utilisant la fonction de sauvegarde cloud.",
          "title": "Cr\xE9er ou Importer un Portefeuille"
        },
        "step3": {
          "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
          "title": "Appuyez sur le bouton de scan"
        }
      }
    }
  },
  "zilpay": {
    "qr_code": {
      "step1": {
        "title": "Ouvrez l'application ZilPay",
        "description": "Ajoutez ZilPay \xE0 votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      "step2": {
        "title": "Cr\xE9er ou Importer un Portefeuille",
        "description": "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
      },
      "step3": {
        "title": "Appuyez sur le bouton de scan",
        "description": "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille."
      }
    }
  }
}
`;
export {
  fr_FR_default as default
};
